export default __webpack_public_path__ + "static/media/edit-client-example.c08c30de.png";